import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import styled from 'styled-components';
import Header from './Header';
import SEO from './SEO';
import theme from '../styles/mui-theme';
import Footer from './Footer';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const LayoutContainer = styled.div`
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
  padding: 1em;
  flex: 1;
`;

interface LayoutProps {
  children: React.ReactElement | React.ReactElement[];
  customSEO?: boolean;
}

const Layout = ({ children, customSEO }: LayoutProps) => (
  <>
    {!customSEO && <SEO />}
    <ThemeProvider theme={theme}>
      <PageWrapper>
        <LayoutContainer>
          <CssBaseline />
          <Header />
          {children}
        </LayoutContainer>
        <Footer />
      </PageWrapper>
    </ThemeProvider>
  </>
);

export default Layout;
